const organization_details = {
    departments: {
        leader: 'Sorumlu',
        leaders: 'Bölüm sorumluları',
        led_departments: 'Yönettiğiniz bölümler',
        edit_leaders: 'Sorumluları yönet',
        add_leader: 'Ekle',
        remove_leader: 'Kaldır',
        no_leaders: 'Sorumlu atanmamış',
        local: 'Yerel yönetim',
        managed_members: 'Yönetim kapsamındaki üyeler',
        leader_scope_hint: 'Bölümlerinizdeki ve alt bölümlerdeki üyelikleri yönetin.',
        leader_permission_hint: 'Sorumlular kendi bölümleri ve alt bölümlerdeki üyelikleri yönetir; kuruluş rollerini veya hiyerarşiyi değiştiremez.',
        primary_synced: 'Ana bölüm Feishu tarafından yönetilir.',
        status_active: 'Etkin',
        status_suspended: 'Askıya alındı',
        status_departed: 'Ayrıldı',
        status_pending: 'Etkinleştirme bekliyor',
        search: 'Ara',
        previous_page: 'Önceki sayfa',
        next_page: 'Sonraki sayfa',
        directory_title: 'Kuruluş üyeleri',
        member_name: 'Üye',
        search_members: 'Ada veya kullanıcı adına göre ara',
        include_descendants: 'Alt bölümleri dahil et',
        no_members: 'Eşleşen üye yok.',
        all_members: 'Tüm üyeler',
        all_departments: 'Tüm bölümler',
        edit_member: 'Bölümleri düzenle',
        add_child: 'Alt bölüm ekle',
        expand_department: '{{name}} genişlet',
        collapse_department: '{{name}} daralt',
        title: 'Departmanlar',
        description: 'Bu kuruluşun departmanlarını ve üye atamalarını yönetin.',
        create: 'Departman oluştur',
        edit: 'Departmanı düzenle',
        name: 'Departman adı',
        parent: 'Üst departman',
        root: 'Üst departman yok',
        id: 'Departman kimliği',
        members: 'Üyelerin departmanları',
        member_id: 'Üye kullanıcı kimliği',
        primary: 'Birincil departman',
        none: 'Ayarlanmadı',
        assignments: 'Departman atamaları',
        no_assignments: 'Henüz departman ataması yok.',
        assignment_hint: 'Yerel departmanları ve isteğe bağlı birincil departmanı atayın. Dizin atamaları salt okunurdur.',
        empty: 'Henüz departman yok.',
        readonly: 'Departmanları ve atamalarınızı görebilirsiniz. Değişiklik için kuruluş yöneticisine başvurun.',
        load_error: 'Veriler yüklenemedi. Yeniden deneyin.',
        mutation_error: 'Kaydedilemedi. İzinleri, üyeliği ve departman hiyerarşisini kontrol edin.',
        loading: 'Yükleniyor…',
        synced: 'Dizin tarafından yönetiliyor',
        choose: 'Departman ara',
        organizations_title: 'Kuruluşlar ve departmanlar',
        organizations_description: 'Departmanlarını görmek veya yönetmek için bir kuruluş seçin.',
        no_organizations: 'Bir kuruluşa üye değilsiniz. Yöneticinizle iletişime geçin.',
        organization: 'Geçerli kuruluş',
        choose_organization: 'Kuruluş seçin',
        delete_title: 'Departmanı sil',
        delete_description: '“{{name}}” silinsin mi? Önce üyeleri ve alt departmanları taşıyın.',
    },
    directory: {
        leaders_label: 'Bölüm sorumlulukları',
        local_department_leader: 'Yerel olarak atanmış bölüm sorumlusu',
        status_active: 'Etkin',
        status_suspended: 'Askıya alındı',
        status_departed: 'Ayrıldı',
        status_pending: 'Etkinleştirme bekliyor',
        profiles_label: 'Kaynak profilleri',
        primary_label: 'Ana bölüm değişiklikleri',
        deactivated_label: 'Devre dışı kimlikler',
        reactivated_label: 'Yeniden etkin kimlikler',
        lifecycle_notice: 'Korunan rol atamaları: {{count}}. Yeniden etkinleştirme önceki izinleri geri getirir.',
        title: 'Feishu dizini',
        description: 'Feishu bağlayıcısıyla bu kuruluşa departmanları ve üyeleri aktarın.',
        identity_notice: 'Dizin sağlama özelliği etkin bir bağlayıcı kullanın. Mevcut bağlayıcının kimliğini değiştirmek hesap geçişi gerektirir.',
        connector: 'Feishu bağlayıcı kimliği',
        preview: 'Eşitlemeyi önizle',
        preview_title: 'Eşitleme önizlemesi',
        preview_description: 'Aktarmadan önce dizini gözden geçirin. Değişirse yeniden önizleyin.',
        import: 'Eşitlemeyi onayla',
        success: '{{departments}} departman ve {{users}} üye aktarıldı; {{createdUsers}} hesap oluşturuldu. {{removedDepartments}} departman, {{removedMemberships}} üyelik ve {{removedAssignments}} atama kaldırıldı.',
        failure: 'Dizin okunamadı veya aktarılamadı. Bağlayıcı izinlerini ve görünürlüğünü kontrol edip yeniden önizleyin.',
        behavior_title: 'Aktarım biçimi',
        mode: 'Adları, avatarları, bölümleri ve ana bölümleri eşitleyin. Eksik veya etkin olmayan üyeler yalnızca bu kuruluşa erişimi kaybeder; roller, yerel atamalar, genel hesaplar ve diğer kuruluş kimlikleri korunur. E-posta ve telefon kaynak bilgisidir, giriş kimlik bilgisi değildir.',
        limits: 'Aktarım başına: 1000 departman, 5000 kullanıcı, 10000 atama; okuma süresi 60 saniye. Eksik veya aşırı büyük aktarımlar reddedilir.',
        counts: '{{departments}} departman · {{users}} üye',
        departments_label: 'Departmanlar',
        members_label: 'Kuruluş üyelikleri',
        assignments_label: 'Departman atamaları',
        item: 'Öğe',
        added: 'Ekle',
        updated: 'Güncelle',
        removed: 'Kaldır',
        cleanup_notice: 'Adları, avatarları, bölümleri ve ana bölümleri eşitleyin. Eksik veya etkin olmayan üyeler yalnızca bu kuruluşa erişimi kaybeder; roller, yerel atamalar, genel hesaplar ve diğer kuruluş kimlikleri korunur. E-posta ve telefon kaynak bilgisidir, giriş kimlik bilgisi değildir.',
        conflicts_title: '{{count}} çakışma eşitlemeyi engelliyor. Yerel bağımlılıkları çözün ve yeniden önizleyin.',
        removals_title: 'Kaldırma örnekleri (kategori başına en fazla 20)',
        local_child_department: 'Yerel alt departman',
        unowned_assignment: 'Kaynağı doğrulanmamış yerel veya eski atama',
        local_member_roles: 'Üyenin yerel olarak atanmış rolleri var',
        unlinked_identity: 'Dizin kimliğinin bağlantısı kaldırıldı',
    },
    page_title: 'Kuruluş detayları',
    delete_confirmation: 'Silindiğinde, tüm üyeler bu kuruluştaki üyeliklerini ve rollerini kaybedecek. Bu işlem geri alınamaz.',
    organization_id: 'Kuruluş Kimliği',
    settings_description: 'Organizasyonlar, uygulamalarınıza erişebilen ekipleri, iş müşterilerini ve iş ortaklarını temsil eder.',
    name_placeholder: 'Kuruluşun adı, benzersiz olması gerekli değildir.',
    description_placeholder: 'Kuruluşun açıklaması.',
    member: 'Üye',
    member_other: 'Üyeler',
    add_members_to_organization: 'Üyeleri "{{name}}" kuruluşuna ekle',
    add_members_to_organization_description: 'İsim, e-posta, telefon veya kullanıcı kimliği arayarak uygun kullanıcıları bulun. Var olan üyeler arama sonuçlarında gösterilmez.',
    add_with_organization_role: 'Kuruluş rol(ler)i ile ekle',
    user: 'Kullanıcı',
    application: 'Uygulama',
    application_other: 'Uygulamalar',
    add_applications_to_organization: 'Uygulamaları {{name}} kuruluşuna ekle',
    add_applications_to_organization_description: 'Uygulama kimliği, adı veya açıklaması arayarak uygun uygulamaları bulun. Var olan uygulamalar arama sonuçlarında gösterilmez.',
    at_least_one_application: 'En az bir uygulama gereklidir.',
    remove_application_from_organization: 'Uygulamayı kuruluştan kaldır',
    remove_application_from_organization_description: 'Uygulama kaldırıldığında, bu kuruluştaki ilişkilendirmesini ve rollerini kaybedecek. Bu işlem geri alınamaz.',
    search_application_placeholder: 'Uygulama kimliği, adı veya açıklaması arayarak arayın',
    roles: 'Kuruluş rolleri',
    authorize_to_roles: '"{{name}}"a aşağıdaki rolleri erişim yetkisi verin:',
    edit_organization_roles: 'Kuruluş rollerini düzenle',
    edit_organization_roles_title: '{{name}} kuruluş rollerini düzenle',
    remove_user_from_organization: 'Kullanıcıyı kuruluştan kaldır',
    remove_user_from_organization_description: 'Kaldırıldığında, kullanıcı bu kuruluşta üyeliğini ve rollerini kaybedecek. Bu işlem geri alınamaz.',
    search_user_placeholder: 'İsim, e-posta, telefon veya kullanıcı kimliği ile ara',
    at_least_one_user: 'En az bir kullanıcı gereklidir.',
    organization_roles_tooltip: 'Bu kuruluştaki {{type}} için atanan roller.',
    custom_data: 'Özel veri',
    custom_data_tip: 'Özel veri, kuruluşla ilişkili ek verileri depolamak için kullanılabilen bir JSON nesnesidir.',
    invalid_json_object: 'Geçersiz JSON nesnesi.',
    branding: {
        name: 'Markalaşma',
        description: 'Kuruluş seviyesindeki oturum açma deneyiminizi özelleştirin.',
        organization_level_sie: 'Kuruluş seviyesinde oturum açma deneyimi',
        organization_level_sie_switch: 'Kuruluş seviyesindeki oturum açma deneyimini etkinleştirin ve kuruluşa özel markalamayı ayarlayın. Devre dışı bırakılırsa önce uygulama seviyesindeki oturum açmaya, ardından genel (omni) oturum açma deneyimine geri döner.',
        logo: 'Kuruluş logoları',
        logo_tooltip: 'Bu logoyu oturum açma deneyiminde görüntülemek için kuruluş kimliğini geçirebilirsiniz; koyu mod etkinse logonun koyu sürümü omni oturum açma deneyimi ayarlarında gereklidir. <a>Devamını oku</a>',
    },
    jit: {
        title: 'Anında sağlama',
        description: 'Kullanıcılar bazı kimlik doğrulama yöntemleriyle ilk oturum açtıklarında otomatik olarak kuruluşa katılabilir ve onlara roller atanır. Anında sağlama için karşılanacak gereksinimleri ayarlayabilirsiniz.',
        email_domain: 'E-posta alan adı sağlama',
        email_domain_description: 'Doğrulanmış e-posta adresleriyle veya doğrulanmış e-posta adresleriyle sosyal oturum açma yoluyla kaydolan yeni kullanıcılar otomatik olarak kuruluşa katılacak. <a>Devamını oku</a>',
        email_domain_placeholder: 'Anında sağlama için e-posta alan adlarını girin',
        invalid_domain: 'Geçersiz alan adı',
        domain_already_added: 'Alan adı zaten eklendi',
        sso_enabled_domain_warning: 'Bir veya daha fazla kurumsal SSO ile ilişkili e-posta alan adları girdiniz. Bu e-postalara sahip kullanıcılar standart SSO akışını takip edecek ve kurumsal SSO sağlama yapılandırılmadıkça bu kuruluşa sağlanmayacaktır.',
        enterprise_sso: 'Kurumsal SSO sağlama',
        no_enterprise_connector_set: 'Henüz herhangi bir kurumsal SSO konektörü kurmadınız. Kurumsal SSO sağlamayı etkinleştirmek için önce bağlayıcılar ekleyin. <a>Kur</a>',
        add_enterprise_connector: 'Kurumsal bağlayıcı ekle',
        enterprise_sso_description: 'Kurumsal SSO yoluyla ilk kez oturum açan yeni veya mevcut kullanıcılar otomatik olarak kuruluşa katılacak. <a>Devamını oku</a>',
        organization_roles: 'Varsayılan kuruluş rolleri',
        organization_roles_description: 'Anında sağlama yoluyla kuruluşa katılan kullanıcılara roller atayın.',
    },
    mfa: {
        title: 'Çok faktörlü kimlik doğrulama (MFA)',
        tip: 'MFA gerektiğinde, MFA yapılandırılmamış kullanıcılar kuruluş jetonu değiştirmeye çalıştıklarında reddedilecektir. Bu ayar kullanıcı kimlik doğrulamasını etkilemez.',
        description: 'Bu kuruluşa erişmek için kullanıcılardan çok faktörlü kimlik doğrulamayı yapılandırmalarını isteyin.',
        no_mfa_warning: 'Kiracınız için hiçbir çok faktörlü kimlik doğrulama yöntemi etkin değil. En az bir <a>çok faktörlü kimlik doğrulama yöntemi</a> etkinleştirilene kadar kullanıcılar bu kuruluşa erişemeyecek.',
    },
};
export default Object.freeze(organization_details);
